<div mat-dialog-title class="matDialogTitle" cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
    <mat-progress-bar mode="indeterminate" class="detaile" [hidden]="!loading"></mat-progress-bar>
    <span>
        <span>{{ title }}</span>
    </span>
    <span (click)="close()">
        <mat-icon class="close">close</mat-icon>
    </span>
</div>

<form [formGroup]="form1_group" (ngSubmit)="check_access(type_task,1)">
    <div mat-dialog-content class="matDialogContent">
        <div class="row pe1">

            <div class='col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-12 pe div_panding' [ngClass]="{en:lang==2}"
                [hidden]="material_type == 2">
                <label for="status_id" class='wh-label'>
                    <span *ngIf="lang == 1"> نام دستگاه : </span>
                    <span *ngIf="lang == 2"> Device Name : </span>
                    <span (click)="reset_input(154)">
                        <mat-icon class="close" class="input_search input_search_pe"
                            [ngClass]="{input_search_en:lang==2}">close</mat-icon>
                    </span>
                    <input class="wh-input" formControlName="device_title" (click)="load_services(154) "
                        [required]="required()  && material_type == 1" readonly>
                    <input class="wh-input" formControlName="device" [hidden]="true"
                        [required]="required()  && material_type == 1" readonly>
                </label>
            </div>

            <div class='col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-12 pe div_panding' [ngClass]="{en:lang==2}"
                [hidden]="material_type == 2">
                <label for="status_id" class='wh-label'>
                    <span *ngIf="lang == 1"> شاخه : </span>
                    <span *ngIf="lang == 2"> Category : </span>
                    <span (click)="reset_input(184)">
                        <mat-icon class="close" class="input_search input_search_pe"
                            [ngClass]="{input_search_en:lang==2}">close</mat-icon>
                    </span>
                    <input class="wh-input" formControlName="cate_title" (click)="load_services(184) "
                        [required]="required() && material_type == 1" readonly>
                    <input class="wh-input" formControlName="cate" [hidden]="true"
                        [required]="required()  && material_type == 1" readonly>
                </label>
            </div>


            <div class='col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-12 pe div_panding' [ngClass]="{en:lang==2}">
                <label for="status_id" class='wh-label'>
                    <span *ngIf="lang == 1 && material_type == 1"> عنوان قطعه مصرف شده: </span>
                    <span *ngIf="lang == 2 && material_type == 1"> Material Name : </span>

                    <span *ngIf="lang == 1 && material_type == 2"> عنوان خدمات </span>
                    <span *ngIf="lang == 2 && material_type == 2"> Services Name : </span>
                    <span (click)="reset_input(195)">
                        <mat-icon class="close" class="input_search input_search_pe"
                            [ngClass]="{input_search_en:lang==2}">close</mat-icon>
                    </span>
                    <input class="wh-input" formControlName="material_title" (click)="load_services(195)" readonly
                        [required]="required()">
                    <input class="wh-input" formControlName="material" [hidden]="true" readonly [required]="required()">
                </label>
            </div>

            <div class='col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-12 pe div_panding' [ngClass]="{en:lang==2}"
                [hidden]="ref == 'reception' ">
                <label for="status_id" class='wh-label'>
                    <span *ngIf="lang == 1"> مرکز هزینه : </span>
                    <span *ngIf="lang == 2"> Cost center : </span>
                    <span (click)="reset_input(186)">
                        <mat-icon class="close" class="input_search input_search_pe"
                            [ngClass]="{input_search_en:lang==2}">close</mat-icon>
                    </span>
                    <input class="wh-input" formControlName="cost_center_title" (click)="load_services(186) "
                        [required]="required1()" readonly>
                    <input class="wh-input" formControlName="cost_center" [hidden]="true" [required]="required1()"
                        readonly>
                </label>
            </div>

            <div class='col-xl-2 col-lg-2 col-md-2 col-sm-2 col-xs-12 pe div_panding' [ngClass]="{en:lang==2}">
                <label for="sort" class='wh-label'>
                    <span *ngIf="lang == 1"> تعداد : </span>
                    <span *ngIf="lang == 2"> Sort : </span>
                    <input class='wh-input' formControlName="number" autocomplete="off" [required]="required()">
                </label>
            </div>

            <div class='col-xl-2 col-lg-2 col-md-2 col-sm-2 col-xs-12 pe div_panding' [ngClass]="{en:lang==2}">
                <label for="sort" class='wh-label'>
                    <span *ngIf="lang == 1"> هزینه : </span>
                    <span *ngIf="lang == 2"> Sort : </span>
                    <input class='wh-input' formControlName="cost" currencyMask autocomplete="off"
                        [required]="required()">
                </label>
            </div>

            <div class='col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-12 pe div_panding' [ngClass]="{en:lang==2}"
                [hidden]="ref != 'reception' ">
                <label for="status_id" class='wh-label'>
                    <span *ngIf="lang == 1"> نام تعمیرکار : </span>
                    <span *ngIf="lang == 2"> Repairman : </span>
                    <span (click)="reset_input(161)">
                        <mat-icon class="close" class="input_search input_search_pe"
                            [ngClass]="{input_search_en:lang==2}">close</mat-icon>
                    </span>
                    <input class="wh-input" formControlName="repairman_title" (click)="load_services(161)" readonly>
                    <input class="wh-input" formControlName="repairman" [hidden]="true" readonly>
                </label>
            </div>

            <div class='col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-12 pe div_panding' [ngClass]="{en:lang==2}"
                [hidden]="true">
                <label for="sort" class='wh-label'>
                    <span *ngIf="lang == 1"> ترتیب : </span>
                    <span *ngIf="lang == 2"> Sort : </span>
                    <input class='wh-input' formControlName="sort" autocomplete="off">
                </label>
            </div>


            <div class='col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 pe div_panding' [ngClass]="{en:lang==2}">
                <label for="sort" class='wh-label'>
                    <span *ngIf="lang == 1"> توضیحات : </span>
                    <span *ngIf="lang == 2"> Comment : </span>
                    <textarea style="height:10rem" class='wh-input' formControlName="comment" autocomplete="off">
                    </textarea>
                </label>
            </div>

        </div>
    </div>

    <div mat-dialog-actions class="matDialogActions">
        <button type="submit" [disabled]="!form1_group.valid" class="btn_pe" [ngClass]="{btn_en:lang == 2}"
            *ngIf="type_task == 1 || type_task == 2">
            <span *ngIf="lang == 2">Save</span>
            <span *ngIf="lang == 1">ذخیره</span>
        </button>
        <button type="submit" class="btn_pe" [ngClass]="{btn_en:lang == 2}" *ngIf="type_task == 3">
            <span *ngIf="lang == 2">Search</span>
            <span *ngIf="lang == 1">جستجو</span>
        </button>
        <button type="button" class="btn_pe" [ngClass]="{btn_en:lang == 2}" *ngIf="type_task == 3"
            (click)="check_access(type_task,2)">
            <span *ngIf="lang == 2">Excel</span>
            <span *ngIf="lang == 1">خروجی اکسل</span>
        </button>
    </div>
</form>